import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'titleCase'
})
export class TitleCasePipe implements PipeTransform {
    transform(name : string) {
        if (!name) return name;

        return name.replace(/[A-Za-z]+\s*/g, function (val) {
            if (/^[Ii]+$/.test(val)) {
                return val.toUpperCase();
            } else {
                return val[0].toUpperCase() + val.substr(1).toLowerCase();
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/pipes/titlecase.pipe.ts